import type { SVGProps } from 'react'
const SvgSyApple = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" width={24} height={24} {...props}>
		<path d="M365.6 264.2c-.5-56.4 46.1-83.8 48.3-85.1-26.4-38.5-67.4-43.8-81.8-44.2-34.4-3.6-67.8 20.6-85.3 20.6-17.9 0-44.9-20.2-73.9-19.6-37.4.6-72.4 22.2-91.6 55.9-39.6 68.6-10.1 169.4 27.9 224.9 19 27.2 41.2 57.5 70.2 56.4 28.4-1.2 39-18.1 73.3-18.1 34 0 43.9 18.1 73.5 17.4 30.5-.5 49.7-27.3 68-54.7 21.9-31.1 30.8-61.8 31.1-63.4-.6-.2-59.1-22.6-59.7-90.1m-56-165.7c15.3-19.1 25.7-45.1 22.8-71.5-22.1 1-49.8 15.3-65.7 34-14.1 16.5-26.7 43.5-23.4 68.9 24.9 1.8 50.4-12.6 66.3-31.4" />
	</svg>
)
export default SvgSyApple
